import { types } from 'mobx-state-tree';

import NumberIdentifier from '../types/NumberIdentifier';


const Rate = types.model('Rate', {
    id: types.union(NumberIdentifier, types.identifier), // Rate API uses integer ids, but older versions of the API used string ids
    value: types.maybeNull(types.number),
    regularPayment: types.maybeNull(types.integer),
    lumpSum: types.maybeNull(types.integer),
    description: types.maybeNull(types.string),
    rateHold: types.maybeNull(types.integer),
    insurable: types.maybeNull(types.string),
    isPreApproval: types.maybeNull(types.boolean),
});

export default Rate;
